import { createSlice } from '@reduxjs/toolkit';
import { UserIssuedInvoice } from '../../@types/UserIssuedInvoice.type';

export type InvoiceTypePreselected = 'income' | 'expense' | 'payment' | 'complement' | 'payroll' | null;

type InvoicingInitialState = {
	currentPage: string;
	showModalStamps: boolean;
	avaibleSteps: number;
	currentStep: number;
	issuedInvoices: UserIssuedInvoice[];
	issuerName: string | null;
	preselectedInvoiceType: InvoiceTypePreselected;
	/** UUID de la factura PPD desde la que se abrió el flujo de complemento de pago. */
	preselectedPpdInvoiceUuid: string | null;
	testingMode: boolean;
};

const initialState: InvoicingInitialState = {
	currentPage: 'dashboard',
	showModalStamps: false,
	avaibleSteps: 1,
	currentStep: 1,
	issuedInvoices: [],
	issuerName: null,
	preselectedInvoiceType: null,
	preselectedPpdInvoiceUuid: null,
	testingMode: false,
};

export const invocingSlice = createSlice({
	name: 'invocing',
	initialState,
	reducers: {
		setCurrentInvoicingPage: (state, action) => {
			state.currentPage = action.payload;
		},
		setShowModalStamps: (state, action) => {
			state.showModalStamps = action.payload;
		},
		setInvoicingAvaibleSteps: (state, action) => {
			state.avaibleSteps = action.payload;
		},
		setInvoicingCurrentStep: (state, action) => {
			state.currentStep = action.payload;
		},
		setUserIssuedInvoices: (state, action) => {
			state.issuedInvoices = action.payload;
		},
		setIssuerName: (state, action) => {
			state.issuerName = action.payload;
		},
		setPreselectedInvoiceType: (state, action) => {
			state.preselectedInvoiceType = action.payload;
		},
		setPreselectedPpdInvoiceUuid: (state, action) => {
			state.preselectedPpdInvoiceUuid = action.payload;
		},
		setTestingMode: (state, action) => {
			state.testingMode = action.payload;
		},
	},
});

export const {
	setCurrentInvoicingPage,
	setShowModalStamps,
	setInvoicingAvaibleSteps,
	setInvoicingCurrentStep,
	setUserIssuedInvoices,
	setIssuerName,
	setPreselectedInvoiceType,
	setPreselectedPpdInvoiceUuid,
	setTestingMode,
} = invocingSlice.actions;

export default invocingSlice.reducer;
